import store from '@/store'

export default function Initializer() {
    console.log('bootstrap');
    store.dispatch('loadUser');
}
